
import store from '../store';

export default function (action, subject) {
	const response = store.getters.ability.can(action, subject)
	if (!response) {
		console.warn(`RBAC: User does not have permission to ${action}-${subject}`)
	}

	return response
}